module.exports = __webpack_public_path__ + "img/gs-img.28ae12b2.jpg";